import { useState, useRef } from "react";
import PropTypes from "prop-types";
import {
  ButtonGroup,
  Button,
  Popper,
  Grow,
  ClickAwayListener,
  Paper,
  MenuList,
} from "@mui/material";
import { ArrowDropDown, CalculateOutlined } from "@mui/icons-material";

export const SplitButton = ({
  label = "",
  onClick = () => {},
  menuItems = [],
  isDisabled = false,
}) => {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef?.current?.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <ButtonGroup
        ref={anchorRef}
        variant="outlined"
        size="large"
        aria-label="Button with menu"
        disabled={isDisabled}
      >
        <Button startIcon={<CalculateOutlined />} onClick={onClick}>
          {label}
        </Button>
        <Button
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="Button menu"
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <ArrowDropDown />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu">{menuItems}</MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

SplitButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  menuItems: PropTypes.array,
  isDisabled: PropTypes.bool,
};
